<template>
    <div class="login-container">
        <div class="login-bg"></div>
        <div class='login'>
            <div class="login-logo"><img src="../assert/images/logo_login.png" alt="玄武科技" /></div>
            <el-form ref="form" :model="loginData" label-width="0px" v-on:submit.native.prevent="onSubmit">
                <el-form-item>
                    <input type="text" v-model="loginData.username" placeholder="帐号" class="login-input" />
                    <div class="login-input-icon login-input-icon-user"></div>
                </el-form-item>
                <el-form-item>
                    <input type="password" v-model="loginData.password" placeholder="密码" class="login-input" />
                    <div class="login-input-icon login-input-icon-password"></div>
                </el-form-item>
                <el-form-item>
                    <el-checkbox v-model="loginData.isChecked">记住密码</el-checkbox>
                </el-form-item>
                <el-form-item>
                    <button class="login-button">登录</button>
                </el-form-item>
            </el-form>
        </div>

    </div>
</template>
<style>
    .login-container .download_iframe{
      position: absolute;
      right: -170px;
      top: -10px;
      width: 160px;
      height: 260px;
      border: none;
    }
    .login-container {
        width: 100%;
        height: 100%;
        background-image: url(../assert/images/bg.jpg);
        -webkit-background-size: cover;
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        position: relative;
        overflow: hidden;
    }
    .login-bg {
        width: 100%;
        height: 60%;
        position: absolute;
        bottom: 0px;
        left: 0px;
        background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, #f3f5f8 40%);
    }
    .login-copyright {
        font-family: "微软雅黑";
        font-weight: 100;
        width: 100%;
        height: 25px;
        line-height: 25px;
        font-size: 16px;
        position: absolute;
        bottom: 25px;
        left: 0px;
        text-align: center;
        color: #a6a6a6;
    }
    .login {
        width: 550px;
        margin: 20vh auto 0;
        background: rgba(255,255,255,0.7);
        padding: 30px 30px;
        border-radius: 10px;
        position: relative;
        box-shadow: 0 20px 20px 0 rgba(8, 53, 96, 0.15);
    }
    .login-logo {
        margin: 20px auto 20px;
    }
    .login-logo img {
        display: block;
        width: 164px;
        height: 53px;
        margin: 0 auto;
    }

    .login-input {
        box-sizing: border-box;
        width: 100%;
        height: 40px;
        line-height: 40px;
        border: none;
        padding: 0px;
        border-bottom: 1px solid rgba(000,000,000,0.2);
        background-color: transparent;
        padding-left: 40px;
        font-size: 16px;
    }
    .login-input:focus {
        outline: none;
    }
    .login-input-icon {
        width: 40px;
        height: 40px;
        position: absolute;
        top: 0px;
        left: 0px;
        background-repeat: no-repeat;
        background-position: 8px;
    }
    .login-input-icon-user {
        background-image: url(../assert/images/user.png);
    }
    .login-input-icon-password {
        background-image: url(../assert/images/password.png);
    }

    .login-button {
        -webkit-appearance: none;
        appearance: none;
        padding: 0px;
        margin: 0px;
        border: none;
        width: 100%;
        height: 50px;
        border-radius: 25px;
        background-image: linear-gradient(270deg, #608fe9, #6fb1f0);
        color: #ffffff;
        font-size: 16px;
        cursor: pointer;
    }
    .login-button:focus {
        outline: none;
    }
    .login-version {
        position: fixed;
        bottom: 0px;
        right:10px;
        color: #a6a6a6;
    }
</style>

<style>
    .xt-login-container .el-input__inner {
        padding-left: 35px;
    }
</style>
<script>
    import Vue from 'vue'
    import {API_ROOT} from '../config/index'
    export default {
        data() {
            return {
                loginData: {
                    username: '',
                    password: '',
                    isChecked: ''
                }
            }
        },
        created() {
            this.init(
            )
        },
        methods: {
            init() {
                let username = localStorage.getItem("userName")
                let password = localStorage.getItem("password")
                let isChecked = localStorage.getItem("rememberPassword")
                this.loginData.username = username
                this.loginData.password = password
                this.loginData.isChecked = isChecked === 'true' ? true : false
            },
            onSubmit() {
                let username = this.loginData.username
                let password = this.loginData.password
                if(!username){
                    this.$message.warning('请填写用户名！')
                    return
                }
                else if(!password){
                    this.$message.warning('请填写密码！')
                    return
                }else {
                    // 记住密码
                    if(this.loginData.isChecked){
                        localStorage.setItem("userName",username)
                        localStorage.setItem("password",password)
                        localStorage.setItem("rememberPassword",this.loginData.isChecked)
                    }else{
                        localStorage.setItem("userName",'')
                        localStorage.setItem("password",'')
                        localStorage.setItem("rememberPassword",this.loginData.isChecked)
                    }
                    this.$http.post(`/platserv/auth/login`,{
                        username:username,
                        password:password,
                    },{
                        headers:{
                            //请求头配置
                            req_id: '333',
                            app_id: '2'
                        }
                    }).then(response => {
                        //验证成功
                        if(response.ok){
                            let token = response.data.resp_data.token;
                            this.userToken = token ? token : '';
                            localStorage.setItem("userToken",this.userToken);
                            localStorage.setItem("userName",username)
                            localStorage.setItem("menuActive",'1-1')
                            this.$router.replace('/management/enterprise')
                        }
                    },error => {
                        //登录失败
                        this.errorMessage(error)
                    });
                }
            },
            // 显示错误消息
            errorMessage(error) {
                let msg = (error.body && error.body.error_code) || error.statusText || error
                this.$message.error(msg)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Index.vue?d07148b4